'use client';
import { useState } from 'react';
import { SideMenu } from './SideMenu';
import { Portal } from '@/ui/common/Portal/Portal';

type TBackButtonProps = {
    partnerSlug: string;
    partnerWebsite: string;
    phoneNumber: string;
    partnerLogoSrc: string;
};

export const SideMenuButton = ({
    partnerWebsite,
    partnerLogoSrc,
    partnerSlug,
    phoneNumber,
}: TBackButtonProps) => {
    const [isOpenMenu, setIsOpenMenu] = useState(false);

    const onClick = () => {
        setIsOpenMenu((prev) => !prev);
    };

    return (
        <>
            <div
                className="mr-3 cursor-pointer rounded-lg px-[4px] py-[10px] hover:bg-ash-hover"
                onClick={onClick}
            >
                <img
                    src="/icon/Menu.svg"
                    className=" h-[16px] w-[24px] fill-blue-dark stroke-blue-dark"
                    alt="Back"
                />
            </div>
            {isOpenMenu && (
                <Portal>
                    <SideMenu
                        partnerWebsite={partnerWebsite}
                        partnerLogoSrc={partnerLogoSrc}
                        phoneNumber={phoneNumber}
                        partnerSlug={partnerSlug}
                        setIsOpen={setIsOpenMenu}
                    />
                </Portal>
            )}
        </>
    );
};
